import React from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';

const AddressField = ({ source, record = {} }) => {
	const append = (where, what) => {
		if (what && what.trim().length > 0) {
			if (where && where.length) {
				where += ', ';
			}
			where += what;
		}
		return where;
	};

	const nullToEmptyString = what => {
		if (what) {
			return what;
		} else {
			return '';
		}
	};

	const address = get(record, source);
	if (!address) {
		return null;
	}
	var result = '';
	result = append(
		result,
		nullToEmptyString(address.firstName) + ' ' + nullToEmptyString(address.lastName)
	);
	result = append(
		result,
		nullToEmptyString(address.addressLine1) + ' ' + nullToEmptyString(address.houseNumber)
	);
	result = append(result, address.addressLine2);
	result = append(result, nullToEmptyString(address.zip) + ' ' + nullToEmptyString(address.city));
	result = append(result, address.district);
	result = append(result, address.province);
	result = append(result, address.country);
	return <span>{result}</span>;
};

AddressField.propTypes = {
	label: PropTypes.string,
	addLabel: PropTypes.bool,
	record: PropTypes.object,
	source: PropTypes.string.isRequired
};

AddressField.defaultProps = {
	addLabel: true
};

export default AddressField;
